const formatTrimmed = (str) => {
    // 1. 앞뒤 공백 제거
    // 2. 콤마나 슬래시를 공백으로 치환
    // 3. 공백을 "_"로 치환
    return str.trim().replace(/[,/]/g, ' ').replace(/\s+/g, '_');
};

const formatUntrimmed = (str) => {
    return str.trim().replace(/_/g, ' ');
};

const formatUntrimmedArray = (arr) => {
    return arr.map((v) => formatUntrimmed(String(v)));
};

function formatStringArray(format, values) {
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof values[number] != 'undefined' ? values[number] : match;
    });
}

function formatString(format, ...values) {
    return format.replace(/{(\d+)}/g, function (match, number) {
        return typeof values[number] != 'undefined' ? values[number] : match;
    });
}

function stringfyArray(values) {
    let arr = [];
    for (const value of values) {
        if (Array.isArray(value)) {
            arr.push(value.join(', '));
        } else {
            arr.push(value);
        }
    }
    return arr;
}

export { formatTrimmed, formatUntrimmed, formatUntrimmedArray, formatStringArray, formatString, stringfyArray };
